// Keyboard shortcuts for the New menu, in each platform's own style:
//
//                      Mac      Windows / Linux
//   Open the New menu   ⌃N       Alt+N   (Chrome keeps Ctrl+N for a new window)
//   Create an item      ⌥J       Alt+J
//
// Item letters avoid the ones Chrome on Windows keeps for itself with Alt
// (D address bar, E and F its menu). Keys are matched by their physical
// position (event.code): on a Mac ⌥J types "∆".

export const IS_MAC =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || '');

// How a shortcut is written on this platform.
export const itemShortcutLabel = (letter) => (IS_MAC ? `⌥${letter}` : `Alt+${letter}`);
export const MENU_SHORTCUT_LABEL = IS_MAC ? '⌃N' : 'Alt+N';

const letterOf = (event) => {
  const match = /^Key([A-Z])$/.exec(event.code || '');
  return match ? match[1] : null;
};

// Ctrl+N on a Mac, Alt+N elsewhere.
export const isMenuShortcut = (event) => {
  if (event.metaKey || event.shiftKey || event.repeat || letterOf(event) !== 'N') return false;
  return IS_MAC ? event.ctrlKey && !event.altKey : event.altKey && !event.ctrlKey;
};

// The letter of an Alt/⌥ + letter press, or null.
export const itemShortcutLetter = (event) => {
  if (!event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.repeat) return null;
  return letterOf(event);
};

// A key press that belongs to something else: typing in a field (on a Mac
// ⌥C types "ç", so it must not open New client), composing an accented or IME
// character, or a key another control has already handled.
export const isTypingEvent = (event) => {
  if (event.defaultPrevented || event.isComposing || event.keyCode === 229) return true;
  const target = event.target;
  if (!target || !target.tagName) return false;
  const tag = target.tagName.toLowerCase();
  return tag === 'input' || tag === 'textarea' || tag === 'select' || Boolean(target.isContentEditable);
};
